/* HM — panel opinii. Progressive enhancement: pełne teksty opinii i wszystkie zdjęcia są już w HTML, karty poza
   pierwszą porcją mają hidden z serwera; skrypt czyta dane do filtrów/sortowania/szukania z kart (bez blobu JSON —
   Codex 14.09). init() jest idempotentne, destroy() zdejmuje zdarzenia i obserwatora. */
(() => {
  'use strict';
  if (window.HmReviews) { window.HmReviews.init(document); return; }
  const instances = new WeakMap();
  const fold = v => String(v).toLocaleLowerCase('pl').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ł/g, 'l');

  function mount(root) {
    if (instances.has(root)) return instances.get(root);
    const aborter = new AbortController();
    const on = (el, name, fn) => el.addEventListener(name, fn, { signal: aborter.signal });
    const $ = s => root.querySelector(s);
    const $$ = s => [...root.querySelectorAll(s)];
    const grid = $('.hmrv-grid');
    if (!grid) return null;
    const search = $('.hmrv-search input'), photoFilter = $('[data-photo-filter]');
    const ratingSelect = $('[data-rating-select]'), sortSelect = $('[data-sort]'), more = $('.hmrv-load-more');
    const clear = $('.hmrv-clear'), counter = $('.hmrv-counter'), empty = $('.hmrv-empty');

    const cards = $$('.hmrv-card').map((el, index) => {
      const name = el.querySelector('.hmrv-name');
      const text = el.querySelector('.hmrv-text');
      const label = `${text ? text.textContent : ''} ${name ? name.textContent : ''}`;
      return {
        el,
        index: Number(el.dataset.order ?? index),
        id: el.dataset.reviewId,
        rating: Number(el.dataset.rating),
        date: el.dataset.date || '',
        hasPhoto: el.dataset.photos === '1' || !!el.querySelector('.hmrv-photo'),
        text: fold(label)
      };
    }).sort((a, b) => a.index - b.index);
    const byId = new Map(cards.map(card => [card.id, card]));

    const firstCount = Math.max(1, Number(root.dataset.initial) || 6);
    const pageSize = Math.max(1, Number(root.dataset.pageSize) || firstCount);
    const state = { query: '', photos: false, rating: 'all', sort: 'default', limit: firstCount };
    let matches = cards.slice(), frame = 0;

    // rozkład ocen: na telefonie zwinięty przez CSS, ten przycisk go rozwija (bez skoku układu przy starcie)
    const breakdownToggle = $('.hmrv-breakdown-toggle'), histogram = $('.hmrv-histogram');
    if (breakdownToggle && histogram) on(breakdownToggle, 'click', () => {
      const open = breakdownToggle.getAttribute('aria-expanded') !== 'true';
      breakdownToggle.setAttribute('aria-expanded', String(open));
      histogram.classList.toggle('is-open', open);
    });

    function measureText() {
      cards.filter(card => !card.el.hidden).forEach(({ el }) => {
        const text = el.querySelector('.hmrv-text'), toggle = el.querySelector('.hmrv-more');
        if (!text || !toggle || toggle.getAttribute('aria-expanded') === 'true') return;
        text.classList.add('is-collapsed');
        toggle.hidden = text.scrollHeight <= text.clientHeight + 1;
      });
    }
    function scheduleMeasure() { cancelAnimationFrame(frame); frame = requestAnimationFrame(measureText); }

    function render(reset = true) {
      if (reset) state.limit = firstCount;
      matches = cards.filter(card => (!state.query || card.text.includes(state.query))
        && (!state.photos || card.hasPhoto)
        && (state.rating === 'all' || card.rating === Number(state.rating)));
      matches.sort((a, b) => {
        if (state.sort === 'high') return b.rating - a.rating || a.index - b.index;
        if (state.sort === 'low') return a.rating - b.rating || a.index - b.index;
        if (state.sort === 'new' || state.sort === 'old') {
          if (!a.date || !b.date) return Number(!a.date) - Number(!b.date) || a.index - b.index;
          return (state.sort === 'new' ? b.date.localeCompare(a.date) : a.date.localeCompare(b.date)) || a.index - b.index;
        }
        return a.index - b.index;
      });
      const shown = matches.slice(0, state.limit), visible = new Set(shown);
      cards.forEach(card => { card.el.hidden = !visible.has(card); });
      // przenosimy istniejące węzły: pełny tekst, stabilne ID i stan rozwinięcia zostają
      const fragment = document.createDocumentFragment();
      shown.forEach(card => fragment.appendChild(card.el));
      grid.appendChild(fragment);
      if (ratingSelect) ratingSelect.value = state.rating;
      $$('.hmrv-rating-row').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.rating === state.rating)));
      const filtered = !!state.query || state.photos || state.rating !== 'all';
      const label = $('.hmrv-results-label');
      if (label) {
        label.replaceChildren(document.createTextNode(filtered ? 'Pasujące opinie ' : 'Wszystkie opinie '));
        const count = document.createElement('span'); count.textContent = matches.length;
        label.append(count);
      }
      if (clear) clear.hidden = !filtered;
      if (empty) empty.hidden = matches.length > 0;
      if (more) more.hidden = shown.length >= matches.length;
      if (counter) counter.textContent = `Wyświetlono ${shown.length} z ${matches.length} opinii`;
      scheduleMeasure();
    }

    function reset() {
      Object.assign(state, { query: '', photos: false, rating: 'all', sort: 'default' });
      if (search) search.value = '';
      if (photoFilter) photoFilter.checked = false;
      if (sortSelect) sortSelect.value = 'default';
      render();
    }

    if (search) on(search, 'input', () => { state.query = fold(search.value.trim()); render(); });
    if (photoFilter) on(photoFilter, 'change', () => { state.photos = photoFilter.checked; render(); });
    if (ratingSelect) on(ratingSelect, 'change', () => { state.rating = ratingSelect.value; render(); });
    if (sortSelect) on(sortSelect, 'change', () => { state.sort = sortSelect.value; render(); });
    [clear, $('.hmrv-empty-reset')].forEach(b => { if (b) on(b, 'click', () => { reset(); if (search) search.focus({ preventScroll: true }); }); });
    $$('.hmrv-rating-row').forEach(b => on(b, 'click', () => {
      state.rating = state.rating === b.dataset.rating ? 'all' : b.dataset.rating; render();
    }));
    const toggle = $('.hmrv-filter-toggle');
    if (toggle) on(toggle, 'click', () => {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      $('.hmrv-toolbar').classList.toggle('is-open', open);
    });
    if (more) on(more, 'click', () => {
      const previous = Math.min(state.limit, matches.length), y = window.scrollY;
      state.limit += pageSize; render(false);
      matches[previous]?.el.focus({ preventScroll: true });
      window.scrollTo({ top: y, behavior: 'instant' });
    });
    on(grid, 'click', event => {
      const button = event.target.closest('.hmrv-more'); if (!button) return;
      const open = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(open));
      button.textContent = open ? 'Zwiń opinię' : 'Czytaj całość';
      button.closest('.hmrv-card').querySelector('.hmrv-text').classList.toggle('is-collapsed', !open);
    });
    if (sortSelect && cards.some(card => card.date)) {
      ['new', 'old'].forEach(value => {
        const option = sortSelect.querySelector(`[value="${value}"]`);
        if (option) { option.hidden = false; option.disabled = false; }
      });
    }

    // galeria i karta rozwiązują się przez te same stabilne ID zdjęcia i opinii
    const rail = $('.hmrv-rail');
    const photoLinks = [...new Map($$('.hmrv-photo').map(l => [l.dataset.photoId, l])).values()];
    const dialog = $('.hmrv-lightbox'), largeImage = $('.hmrv-large');
    let current = 0, opener = null, scroll = { x: 0, y: 0 }, ownsLock = false;

    function showPhoto(index) {
      current = (index + photoLinks.length) % photoLinks.length;
      const link = photoLinks[current], card = link.dataset.reviewId ? byId.get(link.dataset.reviewId) : null;
      const demo = link.dataset.demo === 'true';
      const thumb = link.querySelector('img');
      largeImage.src = link.dataset.large || link.href;
      largeImage.alt = thumb ? thumb.alt : '';
      $('.hmrv-photo-position').textContent = `Zdjęcie ${current + 1} z ${photoLinks.length}`;
      const title = $('.hmrv-lightbox-title'), body = $('.hmrv-lightbox-text'), stars = $('.hmrv-lightbox-stars');
      title.textContent = card ? card.el.querySelector('.hmrv-name').textContent : '';
      body.textContent = card ? card.el.querySelector('.hmrv-text').textContent : '';
      stars.replaceChildren();
      if (card) stars.appendChild(card.el.querySelector('.hmrv-stars').cloneNode(true));
      const note = $('.hmrv-lightbox-note');
      note.hidden = !demo;
      note.textContent = demo ? 'Przypisanie demonstracyjne. To zdjęcie nie ma jeszcze potwierdzonego powiązania z poniższą opinią.' : '';
      $('.hmrv-lightbox-caption').textContent = thumb ? thumb.alt : '';
      const review = $('.hmrv-lightbox-review');
      review.classList.toggle('hmrv-lightbox-review--photo-only', !card);
      // Codex 14.09: na telefonie przewija się cały dialog, na desktopie panel opinii — zerujemy oba
      review.scrollTop = 0; dialog.scrollTop = 0;
      $('.hmrv-prev').hidden = $('.hmrv-next').hidden = photoLinks.length < 2;
    }
    function closePhoto() { if (dialog && dialog.open) dialog.close(); }

    if (dialog && largeImage && photoLinks.length) {
      on(root, 'click', event => {
        const link = event.target.closest('a[data-photo-id]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0
          || typeof dialog.showModal !== 'function') return;
        event.preventDefault(); opener = link;
        scroll = { x: window.scrollX, y: window.scrollY };
        showPhoto(photoLinks.findIndex(p => p.dataset.photoId === link.dataset.photoId));
        ownsLock = !document.documentElement.classList.contains('hmrv-scroll-locked');
        if (ownsLock) document.documentElement.classList.add('hmrv-scroll-locked');
        dialog.showModal();
      });
      on($('.hmrv-close'), 'click', closePhoto);
      on(dialog, 'click', event => { if (event.target === dialog) closePhoto(); });
      on(dialog, 'close', () => {
        if (ownsLock) document.documentElement.classList.remove('hmrv-scroll-locked');
        ownsLock = false; largeImage.removeAttribute('src');
        if (opener?.isConnected) opener.focus({ preventScroll: true });
        window.scrollTo({ left: scroll.x, top: scroll.y, behavior: 'instant' });
      });
      on(dialog, 'keydown', event => {
        if (event.key === 'Tab') {
          const items = [...dialog.querySelectorAll('button:not([disabled]),[tabindex="0"]')]
            .filter(el => !el.hidden && el.getClientRects().length);
          const first = items[0], last = items.at(-1), active = document.activeElement;
          if ((event.shiftKey && active === first) || (!event.shiftKey && active === last) || !dialog.contains(active)) {
            event.preventDefault(); (event.shiftKey ? last : first).focus();
          }
        }
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); showPhoto(current + (event.key === 'ArrowLeft' ? -1 : 1));
        }
      });
      on($('.hmrv-prev'), 'click', () => showPhoto(current - 1));
      on($('.hmrv-next'), 'click', () => showPhoto(current + 1));
    }

    function galleryState() {
      if (!rail) return;
      const overflows = rail.scrollWidth > rail.clientWidth + 3;
      const nav = $('.hmrv-gallery-nav');
      if (nav) nav.hidden = !overflows;
      const back = $('[data-gallery-step="-1"]'), fwd = $('[data-gallery-step="1"]');
      if (back) back.disabled = rail.scrollLeft < 3;
      if (fwd) fwd.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 3;
    }
    $$('[data-gallery-step]').forEach(b => on(b, 'click', () =>
      rail.scrollBy({ left: Number(b.dataset.galleryStep) * rail.clientWidth * .75, behavior: 'instant' })));
    if (rail) on(rail, 'scroll', galleryState);

    let lastWidth = 0;
    const observer = new ResizeObserver(entries => {
      const width = entries[0].contentRect.width;
      if (width !== lastWidth) { lastWidth = width; scheduleMeasure(); galleryState(); }
    });
    observer.observe(grid);

    if (cards.length < Number(root.dataset.threshold || 0)) $('.hmrv-toolbar').hidden = true;
    // filtr „Ze zdjęciami” ma sens tylko, gdy jakaś karta ma potwierdzone zdjęcie
    if (photoFilter && !cards.some(card => card.hasPhoto)) photoFilter.closest('label').hidden = true;
    render(); galleryState();
    root.classList.add('is-ready');
    // wejście z #reviews w adresie: przeglądarka skacze do kotwicy zanim strona skończy się układać (obrazy, skrypty
    // sekcji wyżej) — po 'load' ustawiamy nagłówek panelu jeszcze raz pod sticky headerem (scroll-margin-top w CSS)
    if (root.id && location.hash === '#' + root.id) {
      let userMoved = false;
      ['wheel', 'touchstart', 'keydown'].forEach(n => window.addEventListener(n, () => { userMoved = true; }, { once: true, passive: true }));
      const settle = () => { if (root.isConnected && !userMoved) root.scrollIntoView({ block: 'start', behavior: 'instant' }); };
      const twice = () => { setTimeout(settle, 50); setTimeout(settle, 900); };
      if (document.readyState === 'complete') twice(); else window.addEventListener('load', twice, { once: true });
    }
    document.fonts?.ready.then(() => { if (root.isConnected && !aborter.signal.aborted) scheduleMeasure(); });

    const instance = {
      reveal(id) {
        const card = byId.get(id); if (!card) return;
        reset(); state.limit = Math.max(firstCount, card.index + 1); render(false);
        card.el.scrollIntoView({ block: 'nearest' });
      },
      destroy() {
        closePhoto();
        if (ownsLock) document.documentElement.classList.remove('hmrv-scroll-locked');
        observer.disconnect(); cancelAnimationFrame(frame); aborter.abort(); root.classList.remove('is-ready'); instances.delete(root);
      }
    };
    instances.set(root, instance); return instance;
  }

  function init(scope) {
    if (!scope) return;
    if (scope.matches?.('.hmrv-panel')) mount(scope);
    scope.querySelectorAll?.('.hmrv-panel').forEach(mount);
  }
  function destroy(scope) {
    if (!scope) return;
    if (scope.matches?.('.hmrv-panel')) instances.get(scope)?.destroy();
    scope.querySelectorAll?.('.hmrv-panel').forEach(root => instances.get(root)?.destroy());
  }
  window.HmReviews = { init, destroy, reveal: (root, id) => mount(root)?.reveal(id) };

  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => destroy(e.target));
  document.addEventListener('shopify:block:select', e => {
    const root = e.target.closest?.('.hmrv-panel');
    const id = e.target.closest?.('.hmrv-card')?.dataset.reviewId || e.target.dataset?.reviewId;
    if (root && id) mount(root)?.reveal(id);
  });
  init(document);
})();
